import { BaseSyntheticEvent, useState } from "react";
import { BiDuplicate } from "react-icons/bi";
import TooltipConfig from "../../../../../components/Tooltip";
import ModalConfirmation from "./ModalConfirmation";

const DuplicateButton = ({ id, name }: { id: string, name: string }) => {
  const [showModal, setShowModal] = useState(false);

  function MouseOver(event: BaseSyntheticEvent) {
    event.target.style.cursor = "pointer";
  }

  const handleModal = (handle: boolean) => {
    setShowModal(handle);
  };

  return (
    <TooltipConfig
      content={["Duplicar"]}
      children={
        <>
          <BiDuplicate
            onMouseOver={MouseOver}
            size={25}
            onClick={() => setShowModal(true)}
          />
          <ModalConfirmation
            show={showModal}
            changeModal={handleModal}
            id={id}
            title={name}
          />
        </>
      }
      placement={"bottom"}
      style={true}
    />
  );
};

export default DuplicateButton;
